export default function (blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  link.click()

  URL.revokeObjectURL(url) // Clean up
}
